<template>
  <div class="bloc">
    <div style="padding: 10px">
      <Title :window="window" style="display:inline-block" :color="'#31a6e1'" :sondageName="sondageName" />
      <div style="display:flex; justify-content:space-between;">
      <NbParticipants :window="window" style="display:inline-block"/>
      <Buttons :viewColidee="viewColidee" style="display:inline-block;"/>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/resultats/components/Title'
import Buttons from '@/components/resultats/components/Buttons'
import NbParticipants from '@/components/resultats/components/NbParticipants'
export default {
  name: 'ToolsBar',
  components: {
    Title,
    Buttons,
    NbParticipants
  },
  props: {
    window: {
      required: true
    },
    viewColidee: {
      required: false
    },
    sondageName: {
      required: true,
      type: String
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/resultats/components/ToolsBar.vue